import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_URL_API;
// axios.defaults.withCredentials = false

function testfunc(path) {
  return axios.post(path, null);
}

export default (app) => {
  app.axios = axios;
  app.$http = axios;

  app.config.globalProperties.axios = axios;
  app.config.globalProperties.$http = axios;
};
export { testfunc };